/** Names as a sentence lists them: "Tom", "Tom and Anna", "Tom, Anna and Jo". */
export const joinNames = (names: string[]): string =>
  names.length > 1
    ? `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`
    : names.join('');
